import SalutationEntity from "../Entities/SalutationEntity";
import CachedBaseService from "./CachedBaseService";

export default class SalutationService extends CachedBaseService<SalutationEntity> {
    private SERVICE_NAME = "SalutationService";
    private ODATA_ROUTE = "salutations";

    protected getServiceName(): string {
        return this.SERVICE_NAME;
    }

    protected getOdataRoute(): string {
        return this.ODATA_ROUTE;
    }

    protected mapDtoToEntity(dto: any): SalutationEntity {
        return SalutationEntity.fromOdata(dto, new SalutationEntity());
    }
}
